import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateDeviceRegistrationSlice = getBulkActionSlice(
    'updateDeviceRegistrationResult',
);

export const selectUpdateDeviceRegistrationUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateDeviceRegistrationResult.uuid;

export const selectUpdateDeviceRegistrationShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateDeviceRegistrationResult.shown;

export const selectUpdateDeviceRegistrationTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateDeviceRegistrationResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = updateDeviceRegistrationSlice.actions;
